module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#edit",
      toString: function () {
        return this.url;
      }
    }